/*jshint esversion: 6 */

import React from 'react';

const CaProfileHeroView = (props) => {
    const { userName ,userEmail, userCountry, backgroundImage, tierLabel, scoreLabel, score,maxPoints,tier } = props;


    return(
        <div className={"ProfilePageHero"} >
            <div className={"ProfilePageHero__innerBg"} style={{backgroundImage:("url("+backgroundImage+")")}} />
            <div className={"ProfilePageHero__innerShade"} />
            <div className={"ProfilePageHero__inner"}>
                <div className={"ProfilePageHero__content"}>
                    <div className={"ProfilePageHero__userDetails"}>{userCountry} • {userEmail}</div>
                    <div className={"ProfilePageHero__name"}>{userName}</div>

                    <div className={"ProfilePageHero__stats"}>
                        <div>
                            <h4>{scoreLabel}</h4>
                            <h3>{score}/{maxPoints}</h3>
                        </div>
                        <div className={"ProfilePageHero__vDiv"} />
                        <div>
                            <h4>{tierLabel}</h4>
                            <h3>{tier}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CaProfileHeroView;





